import isNil from 'lodash/isNil';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import {UserData} from '../../../../../../security-context.model';
import {isSysAdminOrManager} from '../../../../../../utils/permissions-utils';
import {FieldDisablementReason} from '../configured-fields/field-disablement-reason.model';
import {Phase} from '../../../../../../shared/model/phase.model';
import {Application} from '../../../loan-application.model';
import { CheckValue } from './check-value.model';


const hasFieldActionOwnerPermission = (permittedRolesIds?: number[], userData?: UserData, application?: Application) => {
  const userRoleIsAllowed = some(permittedRolesIds, role => some(userData?.roleIds, userRole => userRole === role));
  const userWithinLoanAppBranch = application?.branchId === userData?.branchId;

  return userRoleIsAllowed && userWithinLoanAppBranch;
}

const isUserHasPermission = (permittedRolesIds?: number[], userData?: UserData, application?: Application): boolean => {
  if (isNil(userData)) {
    return false;
  }

  if (isSysAdminOrManager(userData)) {
    return true;
  }

  return hasFieldActionOwnerPermission(permittedRolesIds, userData, application);
};

const hasFieldBeenModifiedByUser = (checkValue?: CheckValue<unknown> | undefined): boolean => {
  if (isNil(checkValue?.value)) {
    return false;
  }

  if (isNil(checkValue?.lastModifiedByUserId)) {
    return false;
  }

  return true;
}

export const getDisablementReason =
  (permittedRolesIds?: number[], userData?: UserData, application?: Application, checkValue?: CheckValue<unknown> | undefined): FieldDisablementReason | undefined => {
    const hasPermission = isUserHasPermission(permittedRolesIds, userData, application);
    if (!hasPermission) {
      return FieldDisablementReason.NO_PERMISSIONS_TO_EDIT
    }

    if (hasFieldBeenModifiedByUser(checkValue)) {
      return FieldDisablementReason.VALUE_ALREADY_MODIFIED;
    }

    return undefined;
  };

export const hasEditableFields = (config?: Phase | undefined, userData?: UserData, application?: Application) => config?.checkGroups?.some(group => group.checks?.some(check =>
  isUserHasPermission(check.roleIds, userData, application))) || false;

